import { TGoogleAccount } from "~/_types/TGoogleAccount";
import { useOverlay } from "~/modules/Common/Overlay";
import { GoogleAccountListToJoinModal } from "../components/GoogleAccountListToJoinModal";

export const useGoogleAccountListToJoin = () => {
  const { open: openOverlay, close: closeOverlay } = useOverlay();

  const openGoogleAccountListToJoinModal = (
    displayName: string,
    onClose: () => void,
  ) =>
    new Promise<TGoogleAccount>((resolve) => {
      openOverlay(GoogleAccountListToJoinModal, {
        onSelect: (selectedGoogleAccount) => {
          resolve(selectedGoogleAccount);
          closeOverlay(GoogleAccountListToJoinModal);
        },
        displayName,
        onClose,
      });
    });

  return {
    openGoogleAccountListToJoinModal,
  };
};
